import { render, staticRenderFns } from "./bffCard.vue?vue&type=template&id=6e040612&scoped=true&"
import script from "./bffCard.vue?vue&type=script&lang=ts&"
export * from "./bffCard.vue?vue&type=script&lang=ts&"
import style0 from "./bffCard.vue?vue&type=style&index=0&id=6e040612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e040612",
  null
  
)

export default component.exports